var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpactPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.33341C21.8813 5.33341 26.6667 10.1187 26.6667 16.0001C26.6667 21.8814 21.8813 26.6667 16 26.6667C10.1187 26.6667 5.33332 21.8814 5.33332 16.0001C5.33332 10.1187 10.1187 5.33341 16 5.33341ZM16 2.66675C8.63599 2.66675 2.66666 8.63608 2.66666 16.0001C2.66666 23.3641 8.63599 29.3334 16 29.3334C23.364 29.3334 29.3333 23.3641 29.3333 16.0001C29.3333 8.63608 23.364 2.66675 16 2.66675ZM16 10.6667C18.9413 10.6667 21.3333 13.0587 21.3333 16.0001C21.3333 18.9414 18.9413 21.3334 16 21.3334C13.0587 21.3334 10.6667 18.9414 10.6667 16.0001C10.6667 13.0587 13.0587 10.6667 16 10.6667ZM16 8.00008C11.5813 8.00008 7.99999 11.5814 7.99999 16.0001C7.99999 20.4187 11.5813 24.0001 16 24.0001C20.4187 24.0001 24 20.4187 24 16.0001C24 11.5814 20.4187 8.00008 16 8.00008ZM16 13.3334C14.5267 13.3334 13.3333 14.5281 13.3333 16.0001C13.3333 17.4721 14.5267 18.6667 16 18.6667C17.4733 18.6667 18.6667 17.4721 18.6667 16.0001C18.6667 14.5281 17.4733 13.3334 16 13.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactPoints);
export default __webpack_public_path__ + "static/media/impact-points.f6d1e4ab.svg";
export { ForwardRef as ReactComponent };